import { PageRouteBuilder } from "@common/route/page-route-builder";
import { DeleteOrphanUsersComponent } from "./delete-orphan-users-page.component";

export const deleteOrphanUsersPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-delete-orphan-users-page", DeleteOrphanUsersComponent)
    .requiresLogin()
    .atUrl("/tools/delete-orphan-users")
    .withTitle("Delete Orphan Users")
    .build();
